import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import MultiplePipeline from './multiple-pipeline-icon.svg';

// @ts-expect-error
function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <MultiplePipeline {...validProps} />;
}
SvgComponent.iconName = 'multiplePipeline';

/**
 * @deprecated This is a legacy icon
 */
export const MultiplePipelineIcon = svgIconWrapper(SvgComponent);
